export const fetchJsonWithRetries = async <T>({
    input,
    init,
    maxRetries,
}: {
    input: RequestInfo | URL;
    init?: RequestInit | undefined;
    maxRetries: number;
}): Promise<T> => {
    for (let i = 0; i < maxRetries; i++) {
        try {
            const res = await fetch(input, init);
            return (await res.json()) as T;
        } catch (err) {
            // noop
        }
    }
    throw new Error('fetch failed');
};
